import React, { useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createFinancialAssetType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function FinancialAssetTypeCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    financialAssetTypeName: "",
    financialAssetTypeDescription: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createFinancialAssetType({
        ...form,
        companyId: COMPANY_ID,
        businessDomainId,
      });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/financial-asset-types`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("financialAssetType.create.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("financialAssetType.name")}
              name="financialAssetTypeName"
              value={form.financialAssetTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("financialAssetType.description")}
              name="financialAssetTypeDescription"
              value={form.financialAssetTypeDescription}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.add")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/financial-asset-types`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
